import { createContext, useContext, useEffect, useState } from "react";

import { USER_ROLES_ARRAY } from "../constants";
import { useAuth } from "../features/auth/AuthContext";
import { useGetCurrentUserCompanyCargosQuery } from "../features/cargo/cargoApiSlice";
import { useCargosViewSwitcher } from "./CargoViewContext";

const POLLING_INTERVAL = 300_000; // 5 minutes

const CompanyCargoTableContext = createContext();

export const CompanyCargoTableProvider = ({ children }) => {
	const { user } = useAuth();
	const { currentView } = useCargosViewSwitcher();

	const [pagination, setPagination] = useState({
		pageIndex: 0,
		pageSize: 50, // Number of rows per page
	});

	const [search, setSearch] = useState("");
	const [status, setStatus] = useState("sale");
	const [shouldLockRefetch, setShouldLockRefetch] = useState(false);
	const [selectedBranch, setSelectedBranch] = useState("all");

	const onStatusChange = (newStatus) => {
		setStatus(newStatus);
		setSearch("");
		setPagination({
			...pagination,
			pageIndex: 0,
		});
	};

	const {
		data: cargos,
		isLoading,
		isFetching,
		refetch,
	} = useGetCurrentUserCompanyCargosQuery(
		{
			status: status,
			page: pagination.pageIndex,
			perPage: pagination.pageSize,
			search: search,
			branch: selectedBranch,
		},
		{
			pollingInterval: shouldLockRefetch ? 0 : POLLING_INTERVAL,
			skipPollingIfUnfocused: true,
			skip: !user || !USER_ROLES_ARRAY.includes(user.role) || currentView !== 2,
		}
	);

	useEffect(() => {
		if (currentView !== 2) {
			setShouldLockRefetch(true);
		} else {
			setShouldLockRefetch(false);
		}
	}, [currentView]);

	const value = {
		cargos,
		isLoading,
		isFetching,
		refetch,
		pagination,
		setPagination,
		search,
		setSearch,
		status,
		onStatusChange,
		setShouldLockRefetch,
		selectedBranch,
		setSelectedBranch,
	};

	return (
		<CompanyCargoTableContext.Provider value={value}>
			{children}
		</CompanyCargoTableContext.Provider>
	);
};

export const useCompanyCargosTable = () => useContext(CompanyCargoTableContext);
